<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IRule } from '@/classes/rules/IRule';
import { createRuleHelper } from '@/helpers/rulesHelper';
import { TextRule } from '@/classes/rules/TextRule';
import { OptionsRule } from '@/classes/rules/OptionsRule';
import { ObjectOnly } from '@/classes/ObjectOnly';
import { projectRules } from '@/helpers/rulesModules/buildProjectRules';
import { INestedRule } from '@/classes/rules/INestedRule';

@Component
export default class ProjectFieldsMixin extends Vue {
  @Prop({ required: true })
  public inputName!: string;

  @Prop({ required: true })
  public value!: string;

  @Prop({ required: true })
  public validatorTrigger!: any;

  @Prop({ type: Object, default: () => projectRules })
  private readonly projectRules!: INestedRule;

  public projectPath: string = 'project';

  get inputLabel(): string {
    return this.$t(`${this.projectPath}.${this.inputName}.label`).toString();
  }
  get inputHint(): string {
    return this.$t(`${this.projectPath}.${this.inputName}.hint`).toString();
  }
  get inputHelp(): string {
    return this.$t(`${this.projectPath}.${this.inputName}.help`).toString();
  }
  get displayHelp(): boolean {
    return this.$te(`${this.projectPath}.${this.inputName}.help`);
  }
  get ruleHelper() {
    return createRuleHelper({ rules: this.projectRules });
  }

  protected getValidatorRule(inputName: string): string | ObjectOnly | undefined {
    const path = `${this.projectPath}.${inputName}`;
    const rule = this.getProjectRule(path.split('.'));
    if (rule === undefined) {
      return undefined;
    }
    if (rule instanceof TextRule) {
      return this.ruleHelper.getVValidateTextRule(rule);
    }
    if (rule instanceof OptionsRule) {
      return this.ruleHelper.getVValidateOptionsRule(rule);
    }
  }

  // Get a rule by its path
  protected getProjectRule(path: string[]): IRule | undefined {
    return this.ruleHelper.getFromRulesDictionary(path);
  }
}
</script>

<style lang="stylus" scoped>
.helper {
  background: #1F489B;
  position: relative;
  padding: 5px;
  width: 15px;
  height: 15px;
  display: inline-block;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
  opacity: 0.4;

  i {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 30px;
  }
}
</style>
